import React from 'react'

export default function AboutUsPage () {
  return (
    <div>
      <h1>AboutUsPage</h1>
      <p>Motivated person who whant to make world better</p>
    </div>
  )
}
